export { default, getStaticProps } from './page/[pageNo]';
export { getStaticPaths } from '@/src/pages/[hnaviCategory]/cost/index';
